export default "__VITE_ASSET__ab8a3e85__"